var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":_vm.color,"elevation":"0"}},[_c('v-card-text',{staticClass:"d-flex align-center"},[_c('v-icon',{staticClass:"mr-4",attrs:{"color":_vm.iconColor}},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"text-body-1 typography1--text"},[_vm._v(_vm._s(_vm.text))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }